import React, { Component } from 'react';
import API from '@/api/api';
// import './liveInfoList.less';
import zhCN from 'antd/es/locale/zh_CN';
import { Table, Button, DatePicker, Select, Modal, message, ConfigProvider } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
const { RangePicker } = DatePicker;
const { Option } = Select;

// /insuranceBroker/brokerList

class BrokerList extends Component {

  constructor(props) {
    super(props);
  }

  state = {

    remarkModal: {
      show: false,
      remark: '',
      recordId: '',
    },

    columns: [//直播列表表头
      {
        title: '用户ID',
        dataIndex: 'userId',
      },
      {
        title: '用户昵称',
        dataIndex: 'nickName',
      },
      {
        title: '注册时间',
        dataIndex: 'registerTimeFormat',
      },
      {
        title: '提交时间',
        dataIndex: 'submitTimeFormat',
      },
      {
        title: '姓名',
        dataIndex: 'userName',
      },
      {
        title: '电话',
        dataIndex: 'userPhone',
      },
      {
        title: '身份证号',
        dataIndex: 'idNum',
      },
      {
        title: '从业年限',
        dataIndex: 'workYear',
      },
      {
        title: '就职保司',
        dataIndex: 'companyName',
      },
      {
        title: '生日',
        dataIndex: 'birthday',
      },
      {
        title: '邀请用户',
        render: (_, record) => (record.userId ? <Button type="primary" onClick={this.lookInvitedUsers.bind(this, record.userId)}>查看</Button> : '')
      },
      {
        title: '资格审核',
        dataIndex: 'statusType',
        render: (statusType, record) => (
          <div className="operateBtnBlock">
            {
              statusType == 0 ? '待提交' :
                statusType == 2 ? '符合-待邀请' :
                  statusType == 3 ? '符合-待参加' :
                    statusType == 4 ? '符合-待邀请&待参加' :
                      statusType == 5 ? '符合-已激活' :
                        statusType == 6 ? '不符合' :
                          statusType == 1 ?
                            record.recordId ?
                              <>
                                <Button type="primary" onClick={this.thdMatch.bind(this, 1, record.recordId)}>符合</Button>
                                <Button style={{ marginLeft: '20px' }} type="danger" onClick={this.thdMatch.bind(this, 0, record.recordId)}>不符合</Button>
                              </> : '' : ''
            }
          </div>
        )
      },
      {
        title: '线下沙龙',
        dataIndex: 'joinSalonStatus',
        render: (joinSalonStatus) => {
          return joinSalonStatus == 1 ? '已参加' : '未参加'
        },
      },
      {
        title: '备注',
        dataIndex: 'remark',
        render: (remark, record) => (
          <>
            <span>{remark}</span>
            {record.recordId && <Button type="primary" onClick={this.openModel.bind(this, record)}>{remark ? '修改' : '添加'}备注</Button>}
          </>
        ),
      }
    ],

    searchCondition: {//直播列表搜索条件
      workYearType: undefined, // 0  < 1年  1 1-2 年 2 2-3 年 3 3-5 年  4  > 5 年
      startTime: undefined,
      endTime: undefined,
      statusType: undefined, // 0 待提交 1  待审核 2 符合-待邀请 3 符合-待参加 4 符合-待邀请&待参加 5 符合-已激活 6 不符合
      joinSalonStatus: undefined, // 0未参加 1已参加
      pageSize: 5,
      pageNo: 1,
    },

    pagination: {
      defaultPageSize: 5,
      hideOnSinglePage: true,
      showTotal: total => `总${total}条`,
      onChange: this.onPaginationChange.bind(this),
    },
    timeSelect: '',
  }

  componentDidMount() {
    this.getListData()
  }

  onPaginationChange(page, pageSize) {
    let { searchCondition } = this.state;
    searchCondition.pageNo = page;
    this.setState({ searchCondition }, () => {
      this.getListData()
    })
  }

  onSearchDateChange = (date) => { //筛选条件 ：时间范围
    let { searchCondition } = this.state;
    let startTime = '', endTime = '';
    if (date.length == 0) {
      startTime = '';
      endTime = '';
    } else {
      startTime = Math.floor(date[0].valueOf() / 1000);
      endTime = Math.floor(date[1].valueOf() / 1000);
    }
    searchCondition.startTime = startTime;
    searchCondition.endTime = endTime;
    this.setState({ searchCondition });
  }

  onSelectChange(type, value) {//下拉框更改
    let { searchCondition } = this.state;
    searchCondition[type] = value
    this.setState({ searchCondition })
  }

  searchForData(type) {
    let { searchCondition } = this.state;
    if ('reset' === type) {
      searchCondition = {
        workYearType: undefined,
        startTime: undefined,
        endTime: undefined,
        statusType: undefined,
        joinSalonStatus: undefined,
        pageSize: 5,
        pageNo: 1,
      }
      this.setState({ timeSelect: new Date() });
    }
    this.setState({ searchCondition }, () => {
      this.getListData();
    })
  }

  lookInvitedUsers(userId) {
    this.props.history.push({ pathname: '/insuranceBroker/invitationList', state: { userId } })
  }

  async thdMatch(isMatch, recordId) {
    console.log('isMatch, recordId', isMatch, recordId)
    let result = await API.thdMatch({ isMatch, recordId })
    if (result.status == 1) {
      this.getListData();
    }
  }

  openModel(record) {
    let { remarkModal } = this.state;
    remarkModal.remark = record.remark;
    remarkModal.recordId = record.recordId;
    remarkModal.show = true
    this.setState({ remarkModal })
  }

  hideModel() {
    let { remarkModal } = this.state;
    remarkModal.remark = '';
    remarkModal.recordId = '';
    remarkModal.show = false
    this.setState({ remarkModal })
  }

  remarkChange(e) {
    const { remarkModal } = this.state;
    remarkModal.remark = e.target.value;
    this.setState({ remarkModal })
  }

  async thdRemark() {
    let result = await API.thdRemark(this.state.remarkModal);
    if (result.status == 1) {
      message.success('操作成功')
      this.getListData();
      return;
    }
    message.error(result.msg)
  }

  async getListData() {
    let { searchCondition, pagination } = this.state;
    let result = await API.thdCheckList(searchCondition)
    if (result.status == 1) {
      let data = result.data;
      pagination.total = Number(data.totalNum);
      // pagination.current = searchCondition.pageIndex;
      this.setState({
        datas: data.datas,
        pagination
      })
    }
  }

  render() {
    const {
      pagination,
      freezeInfoModal,
      searchCondition,
      columns,
      datas,
      remarkModal,
      timeSelect
    } = this.state;
    return (
      <ConfigProvider locale={zhCN}>
        <div className="searchPane">
          <RangePicker
            className="rangePicker"
            format="YYYY-MM-DD"
            key={timeSelect}
            onChange={this.onSearchDateChange.bind(this)}
            style={{ margin: '0 0 20px 0' }}
          ></RangePicker>
          <Select style={{ width: '150px', margin: '0 0 20px 20px' }} placeholder='请选择从业年限' value={searchCondition.workYearType} onSelect={this.onSelectChange.bind(this, 'workYearType')}>
            <Option value="0">{'<1年'}</Option>
            <Option value="1">1-2年</Option>
            <Option value="2">2-3年</Option>
            <Option value="3">3-5年</Option>
            <Option value="4">{'>5年'}</Option>
          </Select>
          <Select style={{ width: '200px', margin: '0 0 20px 20px' }} placeholder='请选择资格审核状态' value={searchCondition.statusType} onSelect={this.onSelectChange.bind(this, 'statusType')}>
            <Option value="0">待提交</Option>
            <Option value="1">待审核</Option>
            <Option value="2">符合-待邀请</Option>
            <Option value="3">符合-待参加</Option>
            <Option value="4">符合-待邀请&待参加</Option>
            <Option value="5">符合-已激活</Option>
            <Option value="6">不符合</Option>
          </Select>
          <Select style={{ width: '200px', margin: '0 0 20px 20px' }} placeholder='请选择参加线下沙龙状态' value={searchCondition.joinSalonStatus} onSelect={this.onSelectChange.bind(this, 'joinSalonStatus')}>
            <Option value="0">未参加</Option>
            <Option value="1">已参加</Option>
          </Select>
          <Button style={{ margin: '0 0 20px 20px' }} onClick={this.searchForData.bind(this, 'reset')}>重置</Button>
          <Button style={{ margin: '0 0 20px 20px' }} type="primary" onClick={this.searchForData.bind(this)}>搜索</Button>
        </div>
        <Table
          columns={columns}
          dataSource={datas}
          pagination={pagination}
          onChange={this.handleTableChange}
          rowKey='id'
        />
        <Modal
          destroyOnClose={true}
          title='备注'
          onCancel={this.hideModel.bind(this)}
          onOk={this.thdRemark.bind(this)}
          visible={remarkModal.show}
          width={500}
        >
          <div className="modalPane">
            <TextArea value={remarkModal.remark} placeholder="请输入备注" onChange={this.remarkChange.bind(this)}></TextArea>
          </div>
        </Modal>
      </ConfigProvider>
    )
  }
}

export default BrokerList;